<div class="procedures-list">
  @if ((null == selectedProcedure || '' == selectedProcedure) && inProgressProceduresList.length > 0) {
    <h2>Actions en cours</h2>
  }
  @if ((null == selectedProcedure || '' == selectedProcedure) && inProgressProceduresList.length > 0) {
    <div class="procedure-grid w-100 mb-4">
      @for (procedure of inProgressProceduresList; track procedure) {
        <div class="col-12" (click)="getInProgressProcedure(procedure)">
          <app-procedure-card
            [icon]="'icons/procedures/msisdn/'+procedure.code+'.png'"
            [cursor]="true"
            [text]="procedure.label"
            [status]="procedure.status"
            [priceDetails]="getPrice(procedure.code, procedure.section == 'option', false)"
          ></app-procedure-card>
        </div>
      }
    </div>
  }

  @if ((null == selectedProcedure || '' == selectedProcedure) && proceduresList.length > 0) {
    <h2>Actions disponibles</h2>
  }
  @if ((null == selectedProcedure || '' == selectedProcedure) && proceduresList.length > 0) {
    <div class="procedure-grid w-100 mb-4">
      @for (procedure of proceduresList; track procedure) {
        <div class="col-12" (click)="getProcedure(procedure)">
          <app-procedure-card
            [icon]="'icons/procedures/msisdn/'+procedure.code+'.png'"
            [cursor]="true"
            [text]="procedure.label"
            [status]="procedure.status"
            [priceDetails]="getPrice(procedure.code, procedure.section == 'option', false)"
          ></app-procedure-card>
        </div>
      }
    </div>
  }

  @if ((null == selectedProcedure || '' == selectedProcedure) && activeOptionProceduresList.length > 0) {
    <div [className]="'hr-'+environment.data.brand"></div>
  }

  @if ((null == selectedProcedure || '' == selectedProcedure) && activeOptionProceduresList.length > 0) {
    <h2>Options activées</h2>
  }
  @if ((null == selectedProcedure || '' == selectedProcedure) && activeOptionProceduresList.length > 0) {
    <div class="procedure-grid w-100 mb-4">
      @for (procedure of activeOptionProceduresList; track procedure) {
        <div class="col-12" (click)="getProcedure(procedure)">
          <app-procedure-card
            [icon]="'icons/procedures/msisdn/'+procedure.code+'.png'"
            [cursor]="true"
            [text]="procedure.label"
            [status]="procedure.status"
            [priceDetails]="getPrice(procedure.code, true, false)"
          ></app-procedure-card>
        </div>
      }
    </div>
  }

  @if ((null == selectedProcedure || '' == selectedProcedure) && optionProceduresList.length > 0) {
    <div [className]="'hr-'+environment.data.brand"></div>
  }

  @if ((null == selectedProcedure || '' == selectedProcedure) && optionProceduresList.length > 0) {
    <h2>Options disponibles</h2>
  }
  @if ((null == selectedProcedure || '' == selectedProcedure) && optionProceduresList.length > 0) {
    <div class="procedure-grid w-100 mb-4">
      @for (procedure of optionProceduresList; track procedure) {
        <div class="col-12" (click)="getProcedure(procedure)">
          <app-procedure-card
            [icon]="'icons/procedures/msisdn/'+procedure.code+'.png'"
            [cursor]="true"
            [text]="procedure.label"
            [status]="procedure.status"
            [priceDetails]="getPrice(procedure.code, true, false)"
          ></app-procedure-card>
        </div>
      }
    </div>
  }
</div>

@if (constHelper.PROCEDURE_TERMINATE_LINE == selectedProcedure) {
  <app-terminate-line [procedureCode]="selectedProcedure" [line]="selectedLine" [landLine]="null"></app-terminate-line>
}
@if (constHelper.PROCEDURE_IDENTIFY_LINE == selectedProcedure) {
  <app-identify-line [procedureCode]="selectedProcedure" [line]="selectedLine" [name]="selectedLine.description" [landLine]="null"></app-identify-line>
}
@if (constHelper.PROCEDURE_TECHNICAL_ASSISTANCE == selectedProcedure) {
  <app-technical-assistance [procedureCode]="selectedProcedure" [line]="selectedLine" [landLine]="null"></app-technical-assistance>
}
@if (constHelper.PROCEDURE_CANCEL_TERMINATE_LINE == selectedProcedure) {
  <app-cancel-terminate-line [procedureCode]="selectedProcedure" [line]="selectedLine"></app-cancel-terminate-line>
}
@if (constHelper.PROCEDURE_NOT_RECEIVED_CARD == selectedProcedure) {
  <app-not-received-sim-card [procedureCode]="selectedProcedure" [priceDetails]="getPrice(selectedProcedure, false, true)" [line]="selectedLine"></app-not-received-sim-card>
}
@if (constHelper.PROCEDURE_VOICE_CALL_ASSISTANCE == selectedProcedure) {
  <app-voice-call-assistance [procedureCode]="selectedProcedure" [line]="selectedLine"></app-voice-call-assistance>
}
@if (constHelper.PROCEDURE_MMS_ASSISTANCE == selectedProcedure) {
  <app-mms-assistance [procedureCode]="selectedProcedure" [line]="selectedLine"></app-mms-assistance>
}
@if (constHelper.PROCEDURE_ACTIVATE_SIM_CARD == selectedProcedure) {
  <app-activate-sim-card [procedureCode]="selectedProcedure" [line]="selectedLine" [lastMessage]="lastMessage"></app-activate-sim-card>
}
@if (constHelper.PROCEDURE_CHANGE_NETWORK == selectedProcedure) {
  <app-change-network [procedureCode]="selectedProcedure" [line]="selectedLine" [dates]="portabilityDates" [priceDetails]="getPrice(selectedProcedure, false, true)"></app-change-network>
}
@if (constHelper.PROCEDURE_CHANGE_OFFER == selectedProcedure) {
  <app-change-offer [procedureCode]="selectedProcedure" [line]="selectedLine" [dates]="portabilityDates" [priceDetails]="getPrice(selectedProcedure, false, true)"></app-change-offer>
}
@if (constHelper.PROCEDURE_CHANGE_OFFER_MEF == selectedProcedure) {
  <app-change-offer-mef [procedureCode]="selectedProcedure" [line]="selectedLine"></app-change-offer-mef>
}
@if (constHelper.PROCEDURE_ORDER_SIM_CARD == selectedProcedure) {
  <app-order-sim-card [procedureCode]="selectedProcedure" [line]="selectedLine" [priceDetails]="getPrice(selectedProcedure, false, true)"></app-order-sim-card>
}
@if (constHelper.PROCEDURE_LOSS_STEAL == selectedProcedure) {
  <app-loss-steal [procedureCode]="selectedProcedure" [line]="selectedLine" [priceDetails]="getPrice(selectedProcedure, false, true)" [procedureStatus]="procedureStatus"></app-loss-steal>
}
@if (constHelper.PROCEDURE_CANCEL_SIM_ORDER == selectedProcedure) {
  <app-cancel-sim-order [procedureCode]="selectedProcedure" [line]="selectedLine"></app-cancel-sim-order>
}
@if (constHelper.PROCEDURE_CANCEL_CHANGE_OFFER == selectedProcedure) {
  <app-cancel-change-offer [procedureCode]="selectedProcedure" [line]="selectedLine"></app-cancel-change-offer>
}
@if (constHelper.PROCEDURE_CANCEL_CHANGE_NETWORK == selectedProcedure) {
  <app-cancel-change-network [procedureCode]="selectedProcedure" [line]="selectedLine"></app-cancel-change-network>
}
@if (constHelper.PROCEDURE_CANCEL_LOSS_STEAL == selectedProcedure) {
  <app-cancel-loss-steal [procedureCode]="selectedProcedure" [line]="selectedLine"></app-cancel-loss-steal>
}
@if (constHelper.PROCEDURE_RETRACTION == selectedProcedure) {
  <app-retraction [procedureCode]="selectedProcedure" [line]="selectedLine"></app-retraction>
}
@if (constHelper.PROCEDURE_REFILL_OR_PASS == selectedProcedure) {
  <app-refill-or-pass [procedureCode]="selectedProcedure" [line]="selectedLine" [customer]="customer"></app-refill-or-pass>
}
@if (constHelper.PROCEDURE_CONSUMPTIONS_DETAILS == selectedProcedure) {
  <app-consumptions-details [line]="selectedLine"></app-consumptions-details>
}
<!--app-insurance *ngIf="constHelper.PROCEDURE_INSURANCE == selectedProcedure" [procedureCode]="selectedProcedure" [line]="selectedLine"></app-insurance-->

<!--------------------------------------------------------------------------- OPTIONS ----------------------------------------------------------------------------------->
@if (constHelper.PROCEDURE_ACTIVATION_5G == selectedProcedure) {
  <app-activation-five-g [procedureCode]="selectedProcedure" [line]="selectedLine" [priceDetails]="getPrice(selectedProcedure, true, true)"></app-activation-five-g>
}
@if (constHelper.PROCEDURE_BLOCKING_MULTIMEDIA_PURCHASE == selectedProcedure) {
  <app-multimedia-purchase [procedureCode]="selectedProcedure" [line]="selectedLine"></app-multimedia-purchase>
}
@if (constHelper.PROCEDURE_SURTAX_NUMBER == selectedProcedure) {
  <app-surtax-number [procedureCode]="selectedProcedure" [line]="selectedLine"></app-surtax-number>
}
@if (constHelper.PROCEDURE_TOGGLE_SMS_INTERNET_PLUS == selectedProcedure) {
  <app-toggle-sms-internet-plus [procedureCode]="selectedProcedure" [line]="selectedLine"></app-toggle-sms-internet-plus>
}
@if (constHelper.PROCEDURE_VISUAL_MESSAGING == selectedProcedure) {
  <app-visual-messaging [procedureCode]="selectedProcedure" [line]="selectedLine"></app-visual-messaging>
}
@if (constHelper.PROCEDURE_CONTACTS == selectedProcedure) {
  <app-correspondents-options [procedureCode]="selectedProcedure" [line]="selectedLine" [priceDetails]="getPrice(selectedProcedure, true, true)"></app-correspondents-options>
}
@if (constHelper.PROCEDURE_THREE_WAY_CONFERENCE == selectedProcedure) {
  <app-three-way-conference [procedureCode]="selectedProcedure" [line]="selectedLine" [priceDetails]="getPrice(selectedProcedure, true, true)"></app-three-way-conference>
}
@if (constHelper.PROCEDURE_RECHARGE_DATA == selectedProcedure) {
  <app-recharge-data [procedureCode]="selectedProcedure" [line]="selectedLine" [priceDetails]="getPrice(selectedProcedure, true, true)" [customer]="customer"></app-recharge-data>
}
@if (constHelper.PROCEDURE_RECHARGE_VOICE == selectedProcedure) {
  <app-recharge-voice [procedureCode]="selectedProcedure" [line]="selectedLine" [priceDetails]="getPrice(selectedProcedure, true, true)"></app-recharge-voice>
}
@if (constHelper.PROCEDURE_CHANGE_FINAL_BILLING_DATE == selectedProcedure) {
  <app-change-final-billing-date [selectedPhoneNumber]="selectedLine" [procedureCode]="selectedProcedure" ></app-change-final-billing-date>
}
@if (constHelper.PROCEDURE_UNBLOCK_LINE == selectedProcedure) {
  <app-unblock-line [selectedLine]="selectedLine"></app-unblock-line>
}
@if (constHelper.PROCEDURE_EGELIRR_KO == selectedProcedure) {
  <app-egelirr-ko [selectedLine]="selectedLine"></app-egelirr-ko>
}
@if (constHelper.PROCEDURE_ACTIVATE_NEW_SIM_CARD == selectedProcedure) {
  <app-activate-new-sim-card [procedureCode]="selectedProcedure" [line]="selectedLine"></app-activate-new-sim-card>
}
@if (constHelper.PROCEDURE_HANDLE_LINE_OPTIONS == selectedProcedure) {
  <app-handle-line-options [procedureCode]="selectedProcedure" [line]="selectedLine"></app-handle-line-options>
}
@if (constHelper.PROCEDURE_DEACTIVATE_OPTIONS == selectedProcedure) {
  <app-deactivate-options [procedureCode]="selectedProcedure" [line]="selectedLine"></app-deactivate-options>
}
@if (constHelper.PROCEDURE_CHANGE_OFFER_TO_BASE_PREPAID == selectedProcedure) {
    <app-change-offer-to-base-prepaid [procedureCode]="selectedProcedure" [line]="selectedLine"></app-change-offer-to-base-prepaid>
}
